<script lang="ts" setup>
import { Tag } from '~/components/molecules/tags/Tags.vue'

defineProps<{
  title: string
  tags: Tag[]
}>()

const handleTagClick = (ids: string[]) => {
  const tag = ids?.[0]
  if (tag) return navigateTo({ path: '/aktuell', query: { tag } })
}
</script>

<template>
  <SidebarSection>
    <h4 v-animate="{ animation: 'vertical-reveal' }">{{ title }}</h4>
    <Tags :active="[]" :tags="tags" @update:active="handleTagClick" />
  </SidebarSection>
</template>
